import Action from './Action';
import * as ActionMethods from './ActionMethods';
import TerminationReasonService from '../services/TerminationReasonService';
import EventDispatcher from "../framework/EventDispatcher";

export const TERMINATION_REASONS_LIST = "TERMINATION_REASONS_LIST";

export default function reducer(state = {}, action = {}) {
	switch (action.type) {
		case EventDispatcher.successAction(TERMINATION_REASONS_LIST):
		const terminationReason = action.data;
		return {
			...state,
			terminationReason: terminationReason.terminationReason
		};
		break;
		default:
		return state;
	}
}
export function listTerminationReasons() {
	return dispatch => {
		TerminationReasonService.listTerminationReasons()
		.then(response => {
			const { actionStatus, terminationReason } = response || {};
			if (actionStatus == null || actionStatus.status === "FAIL") {
				this.fail(actionStatus);
			} else {
				EventDispatcher.success(dispatch, TERMINATION_REASONS_LIST, {terminationReason});
			}
		})
		.catch(error => {
			EventDispatcher.error(dispatch, TERMINATION_REASONS_LIST, {error});

		});
	}
}



// WEBPACK FOOTER //
// ./src/opencell/actions/TerminationReasonsActions.js